import { render, staticRenderFns } from "./DashboardLoader.vue?vue&type=template&id=06d88590&"
import script from "./DashboardLoader.vue?vue&type=script&lang=js&"
export * from "./DashboardLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports